import { BillGroupDunningStatusEnum } from '@monetize/types/app';
import { MEntityStatusBadge } from '../../../../components/Monetize/MEntityStatusBadge';

interface DunningStatusBadgeProps {
  dunningStatus: BillGroupDunningStatusEnum;
}

export const DunningStatusBadge = ({
  dunningStatus,
}: DunningStatusBadgeProps) => {
  if (dunningStatus !== BillGroupDunningStatusEnum.IN_DUNNING) {
    return null;
  }

  return <MEntityStatusBadge status="In Dunning" />;
};
